import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { IconButtonComponent } from '@claas/claas-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { AppLauncherComponent } from '../app-launcher.component';

@Component({
  selector: 'app-app-launcher-dialog',
  templateUrl: './app-launcher-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AppLauncherComponent,
    IconButtonComponent,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    TranslateModule,
  ],
})
export class AppLauncherDialogComponent {}
